import React from 'react';
import Box from 'relements/build/esm/ui/box';
import Skeleton from '@src/components/Skeleton';

const commonProps = {
  padding: 'zero',
  marginY: 'lg',
  flexWrap: 'wrap',
};

const LoadingState = () => (
  <Box {...commonProps} flexDirection="column">
    {[...Array(4)].map((i) => (
      <Box key={i}>
        <Skeleton height="72px" width="300px" animation />
      </Box>
    ))}
  </Box>
);
export default LoadingState;
